import { useMutation } from "@apollo/client/react";
import { CheckOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { PublishRecipeDocument } from "../../../gql/generated/graphqlSchema.tsx";
import { LoadingBlocker } from "../../../components/LoadingBlocker.tsx";
import { routes } from "../../../routes.ts";
import { useRecipe } from "../RecipeContext.tsx";

export const SaveRecipeButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { recipe } = useRecipe();
  const [saveRecipe, { loading }] = useMutation(PublishRecipeDocument, {
    onCompleted: () => void navigate({ pathname: routes.recipeDetail.to(recipe.id), hash: location.hash }),
  });

  return (
    <>
      <LoadingBlocker loading={loading} />
      <Button
        icon={<CheckOutlined />}
        loading={loading}
        onClick={() => void saveRecipe({ variables: { id: recipe.id } })}
        type="primary"
      >
        {t("recipes.save")}
      </Button>
    </>
  );
};
